module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('cell', {
    class: ['dof-cell', _vm.clickActivied && 'active-cell', _vm.hasTopBorder && 'cell-top-border', _vm.hasBottomBorder && 'cell-bottom-border', _vm.hasMargin && 'cell-margin', _vm.hasVerticalIndent && 'cell-indent', _vm.desc && 'has-desc'],
    style: _vm.outputCellStyle,
    appendAsTree: true,
    attrs: {
      "canEdit": _vm.canEdit,
      "append": "tree"
    },
    on: {
      "click": _vm.cellClicked,
      "delete": _vm.onDelete,
      "longpress": _vm.showEdit
    }
  }, [_vm._t("itemImg", [(_vm.itemImg && _vm.itemImg != '') ? _c('image', {
    staticClass: ["item-img"],
    attrs: {
      "src": _vm.itemImg,
      "resize": "contain"
    }
  }) : _vm._e()]), _vm._t("label", [(_vm.label) ? _c('div', [_c('text', {
    staticClass: ["cell-label-text"]
  }, [_vm._v(_vm._s(_vm.label))])]) : _vm._e()]), _c('div', {
    staticClass: ["cell-title"]
  }, [_vm._t("title", [_c('text', {
    staticClass: ["cell-content"]
  }, [_vm._v(_vm._s(_vm.title))]), (_vm.desc) ? _c('text', {
    staticClass: ["cell-desc-text"]
  }, [_vm._v(_vm._s(_vm.desc))]) : _vm._e()])], 2), _vm._t("value"), _vm._t("text"), _vm._t("rightText", [(_vm.rightText) ? _c('div', {
    style: {
      paddingRight: _vm.hasArrow ? '24px' : '0px'
    }
  }, [_c('text', {
    staticClass: ["right-text"]
  }, [_vm._v(_vm._s(_vm.rightText))])]) : _vm._e()]), (_vm.hasArrow) ? _c('image', {
    staticClass: ["cell-arrow-icon"],
    style: {
      top: ((_vm.height - 24) / 2) + 'px'
    },
    attrs: {
      "src": _vm.arrowIcon
    }
  }) : _vm._e()], 2)
},staticRenderFns: []}
module.exports.render._withStripped = true


//////////////////
// WEBPACK FOOTER
// ./~/weex-vue-loader/lib/template-compiler.js?id=data-v-de1a6028!./~/weex-vue-loader/lib/selector.js?type=template&index=0!./packages/dof-item/index.vue
// module id = 671
// module chunks = 0 1